export default __webpack_public_path__ + "images/2e12db83e5c50dfdd38b9bf2657d7369-logo.png";